

















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import DigitalCurrencyAlternativeResourceItem1FindDigitalCurrencyAlternatives from './service-for-digital-currency-alternative-resource-item/digital-currency-alternative-resource-item-1-find-digital-currency-alternatives.vue'
import DigitalCurrencyAlternativeResourceItem2FindCustomersSearchingForDigitalCurrencyAlternatives from './service-for-digital-currency-alternative-resource-item/digital-currency-alternative-resource-item-2-find-customers-searching-for-digital-currency-alternatives.vue'

@Component({
  components: {
    DigitalCurrencyAlternativeResourceItem1FindDigitalCurrencyAlternatives,
    DigitalCurrencyAlternativeResourceItem2FindCustomersSearchingForDigitalCurrencyAlternatives
  }
})
class YourAccountHelperComponents8DigitalCurrencyAlternativeResourceItem extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: '' }) accountId?: string

  projectName: string = projectVariables.projectName

  // a list of the indexes of the panels that are open by default
  // [0, 2, 3, 1] means all 4 panels are expanded
  isExandedPanelList: number[] = []

  isOpenAccountDescription: number = 0
  isOpenAccountStatistics: number = 0
  isOpenTransactionStatistics: number = 0
}

export default YourAccountHelperComponents8DigitalCurrencyAlternativeResourceItem

